import { render, staticRenderFns } from "./ChapterConfiguratorGeneral.vue?vue&type=template&id=e16b3054&"
import script from "./ChapterConfiguratorGeneral.vue?vue&type=script&lang=js&"
export * from "./ChapterConfiguratorGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports